<template>
    <div class="text-right">
        <button id="btnDashboardFilter" v-b-toggle.collapse_filter class="btn btn-outline-primary" type="button" title="Add Filter">
            <i class="fal fa-filter"></i>
        </button>
        <b-collapse id="collapse_filter" class="mt-2">
            <b-card>
                <div class="row text-left">
                    <div class="col-sm-12 col-md-6">
                        <p class="card-text mb-1">{{$t('label.records_for')}}</p>
                        <div class="row">
                            <div class="col-sm-12 col-md-6 pr-0">
                                <div class="form-group">
                                    <div class="input-group">
                                        <div class="input-group-prepend w-100">
                                            <label class="input-group-text border-right-0" for="serviceCategory">
                                                <i class="fas fa-calendar-alt"></i>
                                            </label>
                                            <multiselect id="selectLastYear" v-model="selectedLastYearOption" :options="lastYearOption" :searchable="false" :show-labels="false" :placeholder="$t('label.year')" @select="setThisYearOption"></multiselect>
                                            <div class="input-group-append d-flex align-items-center">
                                                <span class="ml-2">{{$t('label.and')}}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div id="errLastYear" class="error-validation"></div>
                                </div> 
                            </div>
                            <div class="col-sm-12 col-md-6">
                                <div class="form-group">
                                    <div class="input-group">
                                        <div class="input-group-prepend w-100">
                                            <label class="input-group-text border-right-0" for="serviceCategory">
                                                <i class="fas fa-calendar-alt"></i>
                                            </label>
                                            <multiselect id="selectThisYear" v-model="selectedThisYearOption" :options="thisYearOption" :searchable="false" :show-labels="false" :placeholder="$t('label.year')"></multiselect>
                                        </div>
                                    </div>
                                    <div id="errThisYear" class="error-validation"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-3">
                        <div class="form-group mt-4">
                            <div class="input-group">
                                <div class="input-group-prepend w-100">
                                    <label class="input-group-text border-right-0">
                                        <i class="fas fa-store"></i>
                                    </label>
                                    <multiselect  :value="selectedOutlet" label="text" track-by="id" :options="outlet" :searchable="false" :show-labels="false" openDirection="below" @select="selectOutlet">
                                        <template slot="option" slot-scope="{ option }">{{option.text}}</template>
                                    </multiselect>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-3 text-right mt-4">
                        <button v-b-toggle.collapse_filter type="button" class="btn btn-primary waves-effect waves-themed" @click="filterDashboard">{{$t('button_link.apply')}}</button>
                    </div>
                </div>
            </b-card>
        </b-collapse>
    </div>
</template>
<script>
import moment from 'moment'
import {getOutletList} from './../../assets/js/dashboard/dashboard'
export default {
    name: 'dashboardInfoFilter',
    data(){
        return{
            lastYearOption: [], thisYearOption: [],
            selectedLastYearOption: parseInt(moment().subtract(1, 'year').startOf('year').format('YYYY')),
            selectedThisYearOption: parseInt(moment().startOf('year').format('YYYY')),
            outlet: [], selectedOutlet: {},
        }
    },
    methods:{
        setThisYearOption(item){
            this.selectedLastYearOption = item
            const year = new Date().getFullYear()
            this.thisYearOption =  Array.from({length: year - (parseInt(this.selectedLastYearOption)-1)}, (value, index) => parseInt(this.selectedLastYearOption) + index)
        },
        selectOutlet(item){
            this.selectedOutlet = item
        },
        filterDashboard(){
            var filterObj = {
                thisYear: this.selectedThisYearOption,
                lastYear: this.selectedLastYearOption,
                outlet: this.selectedOutlet.id
            }
            this.$emit('filterDashboard', filterObj)
        },
    },
    watch:{
        "$i18n.locale"(val){
            this.outlet = [{id: "all", text: this.$i18n.t('label.all', {'item': this.$i18n.t('label.outlet')})}]
            this.outlet.push(...JSON.parse(this.$store.state.outlets))

            var b = Object.assign({}, this.selectedOutlet)
            this.selectedOutlet = this.outlet.filter(obj=> obj.id == b.id)
        }
    },
    async mounted(){
        let $vm = this
        const year = new Date().getFullYear()
        $vm.lastYearOption =  Array.from({length: year - 1969}, (value, index) => 1970 + index)
        $vm.thisYearOption =  Array.from({length: year - (parseInt($vm.selectedLastYearOption)-1)}, (value, index) => parseInt($vm.selectedLastYearOption) + index)

        await getOutletList($vm)
        var outlets = JSON.parse($vm.$store.state.outlets);
        $vm.outlet = [{id: "all", text: $vm.$i18n.t('label.all', {'item': $vm.$i18n.t('label.outlet')})}]
        $vm.outlet.push(...outlets);

        $vm.selectedOutlet = $vm.outlet[0]

        $vm.filterDashboard()
    },
}
</script>